/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stat_AssistsInputs */

const th_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอสซิสต์`)
};

const en_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assists`)
};

const ja_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アシスト`)
};

const zh_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`助攻`)
};

const es_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistencias`)
};

const pt_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assistências`)
};

const id_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asis`)
};

const fr_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passes décisives`)
};

const tl_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assist`)
};

const vi_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiến tạo`)
};

const ko_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어시스트`)
};

const de_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assists`)
};

const ru_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передачи`)
};

const tr_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asist`)
};

const it_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assist`)
};

const pl_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asysty`)
};

const uk_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Передачі`)
};

const hi_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असिस्ट`)
};

const ar_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التمريرات الحاسمة`)
};

const ms_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantuan`)
};

const bn_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাসিস্ট`)
};

const zh_tw2_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`助攻`)
};

const zh_hk2_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`助攻`)
};

const ur_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اسسٹ`)
};

const fa_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`پاس گل`)
};

const sw_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasi za bao`)
};

const nl_stat_assists = /** @type {(inputs: Stat_AssistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assists`)
};

/**
* | output |
* | --- |
* | "Assists" |
*
* @param {Stat_AssistsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const stat_assists = /** @type {((inputs?: Stat_AssistsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stat_AssistsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_stat_assists(inputs)
	if (locale === "ja") return ja_stat_assists(inputs)
	if (locale === "zh") return zh_stat_assists(inputs)
	if (locale === "es") return es_stat_assists(inputs)
	if (locale === "pt") return pt_stat_assists(inputs)
	if (locale === "id") return id_stat_assists(inputs)
	if (locale === "fr") return fr_stat_assists(inputs)
	if (locale === "tl") return tl_stat_assists(inputs)
	if (locale === "vi") return vi_stat_assists(inputs)
	if (locale === "ko") return ko_stat_assists(inputs)
	if (locale === "de") return de_stat_assists(inputs)
	if (locale === "ru") return ru_stat_assists(inputs)
	if (locale === "tr") return tr_stat_assists(inputs)
	if (locale === "it") return it_stat_assists(inputs)
	if (locale === "pl") return pl_stat_assists(inputs)
	if (locale === "uk") return uk_stat_assists(inputs)
	if (locale === "hi") return hi_stat_assists(inputs)
	if (locale === "ar") return ar_stat_assists(inputs)
	if (locale === "ms") return ms_stat_assists(inputs)
	if (locale === "bn") return bn_stat_assists(inputs)
	if (locale === "zh-TW") return zh_tw2_stat_assists(inputs)
	if (locale === "zh-HK") return zh_hk2_stat_assists(inputs)
	if (locale === "ur") return ur_stat_assists(inputs)
	if (locale === "fa") return fa_stat_assists(inputs)
	if (locale === "sw") return sw_stat_assists(inputs)
	if (locale === "nl") return nl_stat_assists(inputs)
	return en_stat_assists(inputs)
});